var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"katex",rawName:"v-katex:auto",value:(_vm.options),expression:"options",arg:"auto"}],attrs:{"id":_vm.name}},[_vm._t("default",function(){return [_vm._v("...")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }